import React from "react";
import { Search } from "lucide-react";
import { TID } from "@/lib/testIds";
import { cn } from "@/lib/utils";

const FILTERS = [
  { key: "All", label: "All", testId: TID.filterAll },
  { key: "Pending", label: "Pending", testId: TID.filterPending },
  { key: "Due Soon", label: "Due Soon", testId: TID.filterDueSoon },
  { key: "Overdue", label: "Overdue", testId: TID.filterOverdue },
  { key: "Completed", label: "Completed", testId: TID.filterCompleted },
];

export default function FilterBar({
  search,
  onSearch,
  statusFilter,
  onStatusFilter,
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div className="relative w-full sm:max-w-sm">
        <Search
          className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#94A3B8]"
          aria-hidden
        />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Search compliance tasks…"
          className="w-full h-9 pl-9 pr-3 rounded-lg border border-[#E2E8F0] bg-white text-sm text-[#0F172A] placeholder:text-[#94A3B8] focus:outline-none focus:ring-2 focus:ring-[#0F172A]/10 focus:border-[#CBD5E1]"
          data-testid={TID.searchInput}
        />
      </div>
      <div className="flex items-center gap-1.5 flex-wrap">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            onClick={() => onStatusFilter(f.key)}
            data-testid={f.testId}
            className={cn(
              "text-xs font-medium px-2.5 h-8 rounded-lg border transition-colors",
              statusFilter === f.key
                ? "bg-[#0F172A] text-white border-[#0F172A]"
                : "bg-white text-[#334155] border-[#E2E8F0] hover:border-[#CBD5E1]"
            )}
          >
            {f.label}
          </button>
        ))}
      </div>
    </div>
  );
}
